module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--28.57f4c2aa.png";